export const DEFAULT_DURATION = 15;
